import { FC, useContext, useEffect, useMemo } from 'react';
import { createGQLDataContext } from 'utils/createDataContext';
import { useGQLQuery } from 'hooks';
import { FetchSharingDetailsQuery, Community } from 'types/graphql';
import { GQLAPIContextType } from 'types/common.types';
import { fetchSharingDetailsConfig } from 'pages/Settings/modals/ShiftDistributionRulesTieringModal/ShiftDistributionRulesTieringModal.constants';
import { SharingData } from 'pages/Settings/modals/ShiftDistributionRulesTieringModal/ShiftDistributionRulesTieringModal.types';

export const ShiftDistributionRulesTieringModalDataContext =
  createGQLDataContext<GQLAPIContextType<SharingData>>();

export const ShiftDistributionRulesTieringModalDataProvider: FC = ({ children }) => {
  const sharingDetailsData = useGQLQuery<FetchSharingDetailsQuery, Community[], {}>(
    fetchSharingDetailsConfig(),
  );

  useEffect(() => {
    sharingDetailsData.fetch();
  }, []); // eslint-disable-line

  const contextValues = useMemo(() => {
    return {
      sharingCommunities: [...sharingDetailsData.data],
    };
  }, [sharingDetailsData]);

  return (
    <ShiftDistributionRulesTieringModalDataContext.Provider value={contextValues}>
      {children}
    </ShiftDistributionRulesTieringModalDataContext.Provider>
  );
};

export const useShiftDistributionRulesTieringModalDataContext =
  (): GQLAPIContextType<SharingData> => useContext(ShiftDistributionRulesTieringModalDataContext);
